import React from 'react';
// import logo from '../../../public/materialdashboard/images/logo-light-icon.png';

function Header() {
  return (
    <>
          <div>
  <header className="topbar">
    <nav className="navbar top-navbar navbar-expand-md navbar-dark">
      {/* ============================================================== */}
      {/* Logo */}
      {/* ============================================================== */}
      <div className="navbar-header">
        <a className="navbar-brand" href="index.html">
          {/* Logo icon */}<b>
            {/*You can put here icon as well // <i class="wi wi-sunset"></i> //*/}
            {/* Dark Logo icon */}
            <img src='/materialdashboard/images/logo-light-icon.png' alt="homepage" className="dark-logo" />
            {/* Light Logo icon */}
          </b>
          {/*End Logo icon */}
          {/* Logo text */}<span>
            {/* dark Logo text */}
            {/* Light Logo text */}
            <img src="/materialdashboard/images/logo-light-text.png" className="light-logo" alt="homepage" /></span> </a>
      </div>
      {/* ============================================================== */}
      {/* End Logo */}
      {/* ============================================================== */}
      <div className="navbar-collapse">
        <ul className="navbar-nav mr-auto">
          {/* This is  */}
          <li className="nav-item"> <a className="nav-link nav-toggler d-block d-sm-none waves-effect waves-dark" onClick={(e) => e.preventDefault()}><i className="ti-menu" /></a> </li>
          <li className="nav-item"> <a className="nav-link sidebartoggler d-none d-lg-block d-md-block waves-effect waves-dark" onClick={(e) => e.preventDefault()}><i className="icon-menu" /></a> </li>
          <li className="nav-item">
            <form className="app-search d-none d-md-block d-lg-block">
              <input type="text" className="form-control" placeholder="Search & enter" />
            </form>
          </li>
        </ul>
        <ul className="navbar-nav my-lg-0">
          <li className="nav-item dropdown u-pro">
            <a className="nav-link dropdown-toggle waves-effect waves-dark profile-pic" href data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><img src="/materialdashboard/images/users/1.jpg" alt="user" className /> <span className="hidden-md-down">Mark &nbsp;<i className="fa fa-angle-down" /></span> </a>
            <div className="dropdown-menu dropdown-menu-right animated flipInY">
              {/* text*/}
              <a href="javascript:void(0)" className="dropdown-item"><i className="ti-user" /> My Profile</a>
              {/* text*/}
              <a href="javascript:void(0)" className="dropdown-item"><i className="ti-wallet" /> My Balance</a>
              {/* text*/}
              <a href="javascript:void(0)" className="dropdown-item"><i className="ti-email" /> Inbox</a>
              {/* text*/}
              <div className="dropdown-divider" />
              {/* text*/}
              <a href="javascript:void(0)" className="dropdown-item"><i className="ti-settings" /> Account Setting</a>
              {/* text*/}
              <div className="dropdown-divider" />
              {/* text*/}
              <a href="login.html" className="dropdown-item"><i className="fa fa-power-off" /> Logout</a>
              {/* text*/}
            </div>
          </li>
                              <li className="nav-item right-side-toggle"> <a className="nav-link  waves-effect waves-light" onClick={(e) => e.preventDefault()}><i className="ti-settings" /></a></li>
        </ul>
      </div>
    </nav>
  </header>
  <br/>
</div>


    </>
  );
}

export default Header;
